import React, { useState } from 'react'
import { Container } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { BsPlus } from "react-icons/bs";
import { BiMinus } from "react-icons/bi";

const AccordionPricing = () => {
  return (
    <section className="accordion-main">
      <div className="accordion-set">
        <h1 className="accordion_heading " data-aos='fade-down'>Frequently Asked Questions</h1>
        <Container className="accordion-cont-sec">
          <Accordion>
            <div className="mb-4">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    How can I register my employees ?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  If you are interested in subscribing to the Oxyzn platform, you can book a demo to have more information and then we will discuss with you the further steps.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    What are the benefits for my employees attending your workshops and webinars?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  Employees participate in virtual activities or challenges,  live video team bonding / happy hour and cooking activities. This creates healthy competition between individuals or teams and a fun way to increase movement, connection, and collaboration.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    Do you offer ad hoc services as a package or end-to-end programs?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  Urban Yoga Lab is a wellbeing consultancy. We have designed an online platform called Oxyzn which is an <br />end-to-end corporate wellbeing programme for every awareness day of the year so you don’t need to design yours. With 50+ monthly live and on-demand events across 45+ wellness categories and more than 100 world-class coaches, Oxyzn is the only platform your employees need to perform at their best.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    Can we do a trial session?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  Your Content Goes Here
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    What are the payment options? Who pays ? Company or employee?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  You can subscribe to the platform as an individual for you and your family. <br />
                  As an employee, the company you work for will subscribe to the platform for the workers.<br />
                  The subscription can be on a monthly basis or on an annual basis (with a 10% discount). The price is per employee and varies depending on the size of your company.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    How many people can attend ?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  The attendance rate varies and can go from 1  to 1000 employees.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="6">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    Where do the sessions take place ?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  Sessions take place online via Zoom.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="7">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    How long are the workshops and sessions ?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  Our wellness classes last between 30 to 45 minutes. Our webinars and workshops last between 30 minutes to 2 hours.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="8">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    What are the benefits for my company to register on your platform ?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  Value for money, Real Time User Data, Saves Time, Interactive Calendar, Variety of Sessions, Internal Comms.<br />
                  The benefits of this type of platform are :<br />
                  <ul>
                    <li>More productivity</li>
                    <li>High employee morale</li>
                    <li>Improve recruitment and retention of employees</li>
                    <li>Reduced absenteeism</li>
                    <li>Reduced health risks</li>
                    <li>Building camaraderie among workers</li>
                    <li>Reducing cost related to health issues</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="9">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    Is Oxyzn available outside the UK ?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  As we can deliver every session, workshops and webinars online, this makes Oxyzn a platform available from anywhere in the world.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="10">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    How does Oxyzn use my data ?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  We explain who we share your data with, how long we retain your data, what rights you have over your data and where we send your data in our Privacy Policy. In a few words : we use your data to design, change and adapt every session we deliver to make it even more suitable for you.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="11">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    Are your coaches/therapists/experts insured?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  All our coaches are insured.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="12">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    What are the privacy policy and terms & conditions ?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  Your Content Goes Here
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="13">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    How many employees can register on the platform?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  As many as you would like. Our offers are designed for companies having 20 employees as well as for companies having 500 employees.
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div className="mb-4">
              <Accordion.Item eventKey="14">
                <Accordion.Header>
                  <span className="accordion-header-text">
                    Are the sessions recorded ?
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  Some of the sessions are recorded. It will be indicated on the event description when the event is registered. <br />

                  Recordings allow people who are busy at the time of the session to view it at a later time.
                </Accordion.Body>
              </Accordion.Item>
            </div>
          </Accordion>
        </Container>
      </div>
    </section>
  )
}

export default AccordionPricing
